import React from 'react';
import Card from '../components/ui/Card';

const DashboardPreferencesPage: React.FC = () => {
  return (
    <div className="p-4 md:p-6 space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold dark:text-text-primary text-light-text-primary mb-2">
          Dashboard Preferences
        </h1>
        <p className="text-sm md:text-base dark:text-text-secondary text-light-text-secondary">
          Customize your dashboard settings and preferences
        </p>
      </div>

      <Card className="p-4 md:p-6">
        <h2 className="text-xl font-semibold dark:text-text-primary text-light-text-primary mb-4">
          Display Settings
        </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium dark:text-text-primary text-light-text-primary mb-2">
              Refresh Interval
            </label>
            <select className="w-full px-3 py-2 dark:bg-background bg-light-background border dark:border-border-color border-light-border-color rounded-md dark:text-text-primary text-light-text-primary">
              <option>Real-time</option>
              <option>Every 5 minutes</option>
              <option>Every 15 minutes</option>
              <option>Every 30 minutes</option>
              <option>Manual only</option>
            </select>
          </div>
        </div>
      </Card>

      <div className="flex flex-col sm:flex-row justify-end gap-4">
        <button className="w-full sm:w-auto px-4 py-2 border dark:border-border-color border-light-border-color rounded-md dark:text-text-primary text-light-text-primary dark:hover:bg-gray-700 hover:bg-gray-100 transition-colors">
          Reset to Defaults
        </button>
        <button className="w-full sm:w-auto px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-hover transition-colors">
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default DashboardPreferencesPage;
